import { SourceHealth } from '@/domain/Health/HealthTypes';
import { getSourceColorByIndex } from '../utils';

interface SourcesListProps {
	sources: SourceHealth[];
}

const SourcesList = ({ sources }: SourcesListProps) => {
	return (
		<div className="space-y-1">
			{sources.map((source, index) => (
				<div key={source.sourceId} className="flex items-center space-x-2">
					<div
						className="w-2 h-2 rounded-full"
						style={{ backgroundColor: getSourceColorByIndex(index) }}
					/>
					<span className="text-xs text-gray-600">{`${source.sourceName} ${source.virtual ? '(virtual)' : '(physical)'}`}</span>
				</div>
			))}
		</div>
	);
};

export default SourcesList;
